import {
    t_PlotData,
    PlotSetting,
} from 'src/app/components/basicFunctionsViews/basic-machine-function-view/basic-view-graph/basic-view-graph.component';

export var initialPlotDataSetting: t_PlotData = {
    x: [0],
    y: [0],
    type: 'date',
    mode: 'lines',
    name: '',
    identifier: {
        ecu_id: 0,
        data_id: 0,
    },
};

export var initialPlotSettings: PlotSetting = {
    data: [initialPlotDataSetting],
    layout: {
        height: 600,
        xaxis: {
            type: 'linear',
            tickmode: 'auto',
            tickangle: 45,
            nticks: 16,
            autorange: true,
            rangeslider: {
                visible: false,
                autorange: true,
            },
        },
        yaxis: {
            type: 'linear',
            tickmode: 'auto',
            rangemode: 'normal',
            autorange: true,
            fixedrange: false,
        },
        margin: {
            b: 60,
            t: 50,
            l: 60,
            r: 60,
            pad: 10,
            autoexpand: true,
        },
        showlegend: true,
        legend: {
            borderwidth: 0,
            xanchor: 'left',
            x: 0,
            y: -0.35,
            yanchor: 'top',
            orientation: 'v',
            itemsizing: 'trace',
            valign: 'middle',
            traceorder: 'normal',
            itemwidth: 30,
            itemclick: 'false',
            itemdoubleclick: 'false',
        },
        colorway: ['#4ba829', '#facf2f', '#1b98e0', '#393c36', '#eb34e2', '#34ebdc', '#9334eb', '#7aeb34', '#ed960c', '#fa0702' ]
    },
    config: {
        displaylogo: false,
        responsive: true,
        scrollZoom: true,
    },
    style: {
        position: 'relative',
        width: '100%',
    },
};

export var initialGridDataSettings = {
    x: [0],
    y: [0],
    type: 'scatter',
    mode: 'markers',
    marker: {
        color: 'rgb(75, 168, 41)',
        size: 12,
        line: {
            width: 1,
            color: 'rgb(57, 60, 54)',
        },
        maxdisplayed: 1,
        symbol: 'cross',
        opacity: 1,
    },
    visible: true,
    showlegend: false,
    cliponaxis: true,
    fill: 'none',
};

export var initialSquareGridSettings = {
    data: [initialGridDataSettings],
    layout: {
        width: 400,
        height: 400,
        plot_bgcolor: 'rgba(255,255,255, 0.7)',
        paper_bgcolor: 'rgba(255,255,255, 0.7)',

        xaxis: {
            range: [110, -110],
            autorange: false,
            fixedrange: true,
            gridwidth: 1,
            tickmode: 'linear',
            dtick: 25,
            tick0: 0,
            zeroline: true,
            zerolinewidth: 2,
            zerolinecolor: 'rgba(75,168,41, 0.8)',
            automargin: true,
            tickangle: 'auto',
            showspikes: false,
            gridcolor: 'rgba(190, 192, 194, 0.6)',
            type: 'linear',
            title: {
                font: {
                    family: 'Roboto',
                    size: 13,
                    color: 'rgb(57, 60, 54)',
                },
            },
            visible: true,
            ticklabelposition: 'outside',
            ticksuffix: '%',
            showticklabels: false,
            tickfont: {
                family: 'Roboto',
                size: 11,
                color: 'rgb(57, 60, 54)',
            },
            showline: false,
            showgrid: true,
            anchor: 'y',
            side: 'bottom',
            layer: 'above traces',
            constrain: 'range',
            constraintoward: 'center',
        },
        yaxis: {
            range: [-110, 110],
            autorange: false,
            fixedrange: true,
            gridwidth: 1,
            tickmode: 'linear',
            dtick: 25,
            tick0: 0,
            zeroline: true,
            zerolinewidth: 2,
            zerolinecolor: 'rgba(75,168,41, 0.8)',
            automargin: true,
            tickangle: 'auto',
            showspikes: false,
            gridcolor: 'rgba(190, 192, 194, 0.6)',
            type: 'linear',
            title: {
                font: {
                    family: 'Roboto',
                    size: 13,
                    color: 'rgb(57, 60, 54)',
                },
            },
            visible: true,
            ticklabelposition: 'outside',
            ticksuffix: '%',
            showticklabels: false,
            tickfont: {
                family: 'Roboto',
                size: 11,
                color: 'rgb(57, 60, 54)',
            },
            showline: false,
            showgrid: true,
            anchor: 'x',
            side: 'left',
            layer: 'above traces',
            constrain: 'range',
            constraintoward: 'middle',
        },
        autosize: false,
        font: {
            family: 'Roboto',
            size: 1,
            color: 'rgb(57, 60, 54)',
        },
        margin: {
            b: 15,
            t: 15,
            l: 15,
            r: 15,
            pad: 0,
            autoexpand: true,
        },
        dragmode: 'zoom',
        clickmode: 'none',
        hovermode: false,
        hidesources: false,
        colorway: ['#4ba829'],
        showlegend: false,
    },
    config: {
        displaylogo: false,
        responsive: true,
        scrollZoom: true,
        displayModeBar: false,
    },
    style: {
        position: 'relative',
        width: '100%',
    },
};
